var spotify_embed = (function ($) {

    var _init = function () {
        window.onSpotifyIframeApiReady = function (IFrameAPI) {
            const element = $('#spotify-podcast-embed');
            const options = {
                uri: element.data('uri')
            };
            const callback = function (EmbedController) {
            };
            IFrameAPI.createController(element[0], options, callback);
        };
    };

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = spotify_embed;